import React,{useRef, useState, useEffect} from "react";
import {X, CircleNotch, Info} from "@phosphor-icons/react";
import layerEvents from "../utils/layerEvents";
import vindrApi from "../utils/vindrapi";
import { Col, Row, Modal, Button} from "react-bootstrap";
import EditableRange from "../components/EditableRange";

class OverlayShadow {

	max = 8;
	min = 6;
	layerId = 'shadow-fill';
	sourceId = 'shadow-source';

	shadowData = {
		method:null,
		updated:false
	};
	constructor() {
		
	}
	handleOpacityChange = (opc) => {
		this.opacity = opc;
		this.setLayerOpacity(this.layerId, opc);
	}

	addLayer(){
		

			if(!this.map.getSource(this.sourceId)){
				this.map.addSource(this.sourceId, {
					type: 'geojson',
					data: this.shadowData.isolines
				});

				//set the opacity if there is a preset
				this.map.addLayer({
					id: this.layerId,
					type: 'fill',
					source: this.sourceId,
					paint: OverlayShadow.layerPaint
				});


	//			setTimeout(()=>{
	//				this.gradient.current.style.background=this.activeLayer.gradient;
	//				this.parent.forceUpdate();
	//			},100);			
				//this.map.on('click', this.handleClick);
				//this.map.on('mousemove', this.setGetter);

				this.map.moveLayer(this.layerId);	

			}
		
	}
	remLayer(){
		
		if(!this.map.getSource(this.sourceId))
			return;
		

		if(this.map.getLayer(this.layerId))
			this.map.removeLayer(this.layerId);
		
		if(this.map.getSource(this.sourceId))
			this.map.removeSource(this.sourceId);
		
		
	}
	getShadowLayer(){
		
		vindrApi.getShadowLayer(this.context.tc.scenario.projectid, this.context.tc.scenario.scenario_id).then((result)=>{
			
			this.shadowData = result;
			this.shadowData.updated = true;
			this.parent.forceUpdate(); //will call this.panelk() on re-render
		});
		
	}
	convertPadding(value){
		
		var p = value-6;
		if(p<0)
			p=0;
		if(p>2)
			p=2;
		
		
		// 0->2 === 0->245px 
		p = (p*122.5);
		return p;
		
	}
	setLayerOpacity(l, opacity){
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = this.map.getLayer(l);
			//console.log(layer.type);
			if(!layer)
				return;
			
			if (layer.type === 'symbol')  {
				this.map.setPaintProperty(l, 'icon-opacity', opc);
				this.map.setPaintProperty(l, 'text-opacity', opc);
			}
			else if(layer.type === 'raster') {
				this.map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				const s = structuredClone(OverlayShadow.scale);
				const newScale = s.map((s)=>{s.opacity *= opacity; return s;});
				var op = OverlayShadow.paintOpacity(newScale);
				this.map.setPaintProperty(l, layer.type+'-opacity', op[layer.type+'-opacity']);
			}
		}
	}
	
	enterOverlay(){
		this.getShadowLayer();
		this.context.tc.sensorModeForce();
	}
	exitOverlay(){
		this.remLayer();
		this.parent.forceUpdate();
		this.context.tc.landownerModeForce();
		
		

	}
	handleClose(){
		
		if(this.parent && this.parent.exitMode)
			this.parent.exitMode();
	}
	handleCalculate(){
		vindrApi.startShadowLayer(this.context.tc.scenario.projectid, this.context.tc.scenario.scenario_id).then((result)=>{
			
			this.shadowData = result;
			this.context.QN.current.show("Shadow calculation in progress. Reload page in a few minutes to see updated data.");
			this.shadowData.updated = true;
			this.parent.forceUpdate(); //will call this.panelk() on re-render
			
			this.handleClose();
		});
	}
	showCalculate(){
		
		
		
		return (
			<Modal className="modalShadow" show={true} onHide={(e)=>this.handleClose(e)}  centered>
				<Modal.Header closeButton>
					<Modal.Title>Calculate shadow levels</Modal.Title>
				</Modal.Header>


						

				<Modal.Body>
					<Row className="mb-3">

						<Col xs="12" className="feedback-text mb-5">
							Shadow levels are not calculated for this scenario yet. This prosess takes a few minutes.
						</Col>
					</Row>
				</Modal.Body>


				<Modal.Footer>
					<Button variant="secondary" onClick={(e)=>this.handleClose()}>Cancel</Button>
					<Button variant="primary" type="submit" onClick={(e)=>this.handleCalculate()}>Start calculation to continue</Button>
				</Modal.Footer>
						
					
			</Modal>
		)
	}
	showControl(){
		return (
			<div className="card overlayShadow">
				<div className="row title">
					Shadow levels
					<span onClick={(e)=>{this.handleClose();}} className="btn btn-close alt btn-sm float-end"><X size={12} /></span>
				</div>
				{
				this.shadowData.state == 'waiting' &&
					<div className="my-3 mx-1">Status : Shadow calculation in progress… This may take a few minutes</div>
				}
				{
				this.shadowData.state != 'waiting' &&
				<>
					<div className="my-3">
						Hours / year
						
						<div className="branded-tooltip">
							<Info size={16} />
							<div className="text">
								<span><Info size={16} /> SHADOW  (Worst Case)</span>

								Calculates the maximum possible shadow flicker duration assuming the sun shines during all daylight hours throughout the year. The rotor plane is always perpendicular to the line between the sun and the receptor. This conservative approach provides the upper limit of shadow impact, useful for regulatory compliance and planning applications.
							</div>
						</div>
					</div>
					<div className="scale">
						<ul>
							{
								OverlayShadow.scale.map((a)=>{
									return (<li><span class="square" style={{backgroundColor:a.color, opacity:a.opacity}}></span> {a.label}</li>)
								})
							}
						</ul>


					</div>
					<Row>
						<Col xs="12 style-name pt-2">
							Layer opacity (%)
						</Col>
						<Col xs="12">
							<EditableRange wrpClassName="mb-3" className="opacity-range-input" min="0" max="100" step="1" value={100} defaultValue={100} onChange={(e)=>{this.handleOpacityChange(e.target.value/100);}} />
						</Col>
					</Row>	
				</>
				}
			</div>
		)
	}
	panel(){
		if(!this.shadowData.updated)
			return;
		
		
		if(this.shadowData.state){
			this.addLayer();
			return this.showControl();
		}
		else
			return this.showCalculate();
		
		
	}
}

OverlayShadow.scale = [
	{
		color: "#2920CD",
		opacity: .2,
		label: "0-10 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .4,
		label: "10-30 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .6,
		label: "30-100 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .8,
		label: "100+ hours / year"
	}
]

OverlayShadow.paintOpacity = (scale)=>{ return {

		'fill-opacity': ['case',
			['<', ['get', 'hours'], 10], scale[0].opacity, 
			['all', ['>=', ['get', 'hours'], 10],['<', ['get', 'hours'], 30]], scale[1].opacity,
			['all', ['>=', ['get', 'hours'], 30],['<', ['get', 'hours'], 100]], scale[2].opacity,
			['>=', ['get', 'hours'], 100], scale[3].opacity, 

			1
		]
	};
}


OverlayShadow.layerPaint = {
	...{
		'fill-color': ['case', 
			['<', ['get', 'hours'], 10], OverlayShadow.scale[0].color, 
			['all', ['>=', ['get', 'hours'], 10],['<', ['get', 'hours'], 30]], OverlayShadow.scale[1].color,
			['all', ['>=', ['get', 'hours'], 30],['<', ['get', 'hours'], 100]], OverlayShadow.scale[2].color,
			['>=', ['get', 'hours'], 100], OverlayShadow.scale[3].color, 

			'#2920CD'
		]
	},
	...OverlayShadow.paintOpacity(OverlayShadow.scale)
};

export default OverlayShadow;